export default "__VITE_ASSET__e79077c5__"